import React from 'react'
import Main from '../../cpn/Main'
import {Col, Divider, Row} from 'antd'
import LedgerTableDept from './LedgerTableDept'
//
import ArapTableDept from './ArapTableDept'

//
import FundTableDept from './FundTableDept';

function StatIndexPersonal() {    
    return (
        <Main  t1='部门利润'>
            <Row gutter={20}>                
                <Col span={6}>
                    <Divider>部门利润汇总</Divider>
                    <Row>
                        <LedgerTableDept />
                        <ArapTableDept />
                        <FundTableDept /> 
                    </Row>
                </Col>                
            </Row>            
        </Main>
    )
}

export default StatIndexPersonal